// Utilidades para cotejar documentos con vehículos existentes (FASE 1 · Vehículos).

const norm = (v) =>
  (v == null ? "" : String(v))
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();

// Matrícula/VIN: solo alfanumérico en mayúsculas.
const normId = (v) => (v == null ? "" : String(v)).toUpperCase().replace(/[^A-Z0-9]/g, "");

const getVal = (obj, k) => (obj && obj[k] && obj[k].valor != null ? obj[k].valor : null);

export const extractVehiculoData = (analisis) => {
  const v = (analisis && analisis.vehiculo) || {};
  return {
    matricula: getVal(v, "matricula"),
    vin: getVal(v, "vin"),
    marca: getVal(v, "marca"),
    modelo: getVal(v, "modelo"),
    titular: getVal(v, "titular"),
    tipo_doc: getVal(v, "tipo_doc_vehiculo"),
  };
};

export const hasVehiculoData = (analisis) => {
  const d = extractVehiculoData(analisis);
  return !!(d.matricula || d.vin || (d.marca && d.modelo));
};

export const scoreVehiculo = (data, veh) => {
  const reasons = [];
  let strong = false;

  if (data.matricula && veh.matricula && normId(data.matricula) === normId(veh.matricula)) {
    reasons.push("matrícula");
    strong = true;
  }
  if (data.vin && veh.vin && normId(data.vin) === normId(veh.vin)) {
    reasons.push("nº de bastidor (VIN)");
    strong = true;
  }
  const marcaEq = data.marca && veh.marca && norm(data.marca) === norm(veh.marca);
  const modeloEq = data.modelo && veh.modelo && norm(data.modelo) === norm(veh.modelo);
  if (marcaEq) reasons.push("marca");
  if (modeloEq) reasons.push("modelo");
  const titEq = data.titular && veh.titular && norm(data.titular) === norm(veh.titular);
  if (titEq) reasons.push("titular");

  let confidence = null;
  if (strong) confidence = "alta";
  else if (marcaEq && modeloEq) confidence = "media";
  else if (marcaEq || modeloEq || titEq) confidence = "baja";

  const score = (strong ? 100 : 0) + (marcaEq ? 2 : 0) + (modeloEq ? 2 : 0) + (titEq ? 1 : 0);
  return { reasons, strong, confidence, score };
};

export const matchVehiculos = (analisis, vehiculos) => {
  const data = extractVehiculoData(analisis);
  if (!hasVehiculoData(analisis) || !vehiculos || vehiculos.length === 0) return { data, candidates: [], best: null };
  const candidates = vehiculos
    .map((veh) => ({ veh, ...scoreVehiculo(data, veh) }))
    .filter((c) => c.reasons.length > 0 && c.confidence)
    .sort((a, b) => b.score - a.score);
  return { data, candidates, best: candidates[0] || null };
};
